import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ic-menu-24-px_82f3a0e22e017fc7b6372c733d584e6a",
  "use": "ic-menu-24-px_82f3a0e22e017fc7b6372c733d584e6a-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" id=\"ic-menu-24-px_82f3a0e22e017fc7b6372c733d584e6a\">\n    <path fill=\"#55586B\" fill-rule=\"evenodd\" d=\"M2 4h20v2H2V4zm0 7h20v2H2v-2zm20 7H2v2h20v-2z\" clip-rule=\"evenodd\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol